/* ==========================================================================
   Koolseed — "Gelince Haber Ver"

   Modal sayfada tek kopya duruyor; tetikleyici hangi ürün için açıldığını
   data niteliğiyle bildiriyor.

   Uç nokta onaya göre seçiliyor (ayrıntı: snippets/ks-notify.liquid):
     · onay kutusu boş  → "contact": kimse abone yapılmıyor, istek mağazanın
                           e-postasına ürün adıyla düşüyor.
     · onay işaretli    → "customer": kişi `gelince-haber-ver` +
                           `stok-bildirim-<handle>` ve onay etiketleriyle
                           abone yapılıyor — verdiği onayın kendisi.

   Gönderim önce fetch ile denenir (sayfa yenilenmesin diye); ağ hatası
   olursa form normal gönderime düşer.
   ========================================================================== */

(function () {
  'use strict';

  class KsNotify extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.tags = this.querySelector('[data-notify-tags]');
      this.productLine = this.querySelector('[data-notify-product]');
      this.done = this.querySelector('[data-notify-done]');
      this.email = this.querySelector('input[type="email"]');
      this.consent = this.querySelector('[data-consent-etk]');
      this.productField = this.querySelector('[data-notify-product-field]');
      this.formType = this.form ? this.form.querySelector('input[name="form_type"]') : null;
      this.release = null;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-ks-close]') || event.target === this) this.close();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.hidden) this.close();
      });

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    open(trigger) {
      this.trigger = trigger;
      const handle = trigger.dataset.notifyHandle || '';
      const title = trigger.dataset.notifyTitle || '';

      if (this.tags) {
        this.tags.value = handle ? `gelince-haber-ver, stok-bildirim-${handle}` : 'gelince-haber-ver';
      }
      if (this.productField) {
        this.productField.value = handle ? `${title} (${handle})` : title;
      }
      if (this.productLine) {
        const template = (window.KS_STRINGS && window.KS_STRINGS.notifyFor) || '{{ title }}';
        this.productLine.textContent = title ? template.replace('{{ title }}', title) : '';
        this.productLine.hidden = !title;
      }
      if (this.done) this.done.hidden = true;
      if (this.form) this.form.hidden = false;
      // Onay kutusu her açılışta boş başlıyor: önceki ürün için verilen
      // işaret bir sonrakine taşınmasın.
      if (this.consent) this.consent.checked = false;
      if (this.formType) this.formType.value = 'contact';

      this.hidden = false;
      window.requestAnimationFrame(() => this.classList.add('is-open'));
      window.KS.lockScroll(true);
      this.release = window.KS.trapFocus(this, this.email);
    }

    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      if (this.release) { this.release(); this.release = null; }
      window.KS.lockScroll(false);
      window.setTimeout(() => { this.hidden = true; }, 260);
      if (this.trigger) this.trigger.focus({ preventScroll: true });
    }

    async onSubmit(event) {
      if (!this.email || !this.email.value.trim()) return; // Tarayıcı doğrulaması halletsin.
      event.preventDefault();

      this.applyConsentTags();

      const button = this.form.querySelector('[type="submit"]');
      if (button) button.classList.add('is-loading');

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('notify failed');
        // Shopify bot doğrulaması isterse yanıt /challenge sayfasına yönlenir;
        // fetch bunu başarılı sayardı. Normal gönderime düşülüyor ki kullanıcı
        // doğrulamayı görüp tamamlayabilsin — yoksa istek sessizce kaybolurdu.
        if (response.redirected && /\/challenge/.test(response.url)) throw new Error('challenge');

        this.form.hidden = true;
        if (this.done) this.done.hidden = false;
      } catch (error) {
        // Ağ hatasında normal gönderime düş; Shopify sayfayı yenileyip kaydeder.
        if (button) button.classList.remove('is-loading');
        this.form.submit();
        return;
      }

      if (button) button.classList.remove('is-loading');
    }
  }

  /* Pazarlama onayı verildiyse kaydı kanıtlayan etiketler eklenir: kanal,
     formun yeri ve onay metninin sürümü. Verilmediyse hiçbiri gitmiyor;
     accepts_marketing de kutu işaretsizken formdan hiç gönderilmiyor. */
  KsNotify.prototype.applyConsentTags = function () {
    const consented = Boolean(this.consent && this.consent.checked);

    // Onay yoksa güvenli uç: iletişim formu, kimse abone yapılmıyor.
    if (this.formType) this.formType.value = consented ? 'customer' : 'contact';

    if (!this.tags) return;
    const base = this.tags.value
      .split(',')
      .map((tag) => tag.trim())
      .filter((tag) => tag && !tag.startsWith('etk-'));
    if (consented) {
      const version = this.dataset.consentVersion || 'v1';
      base.push('etk-onay-eposta', 'etk-kaynak-notify', `etk-metin-${version}`);
    }
    this.tags.value = base.join(', ');
  };

  if (!customElements.get('ks-notify')) customElements.define('ks-notify', KsNotify);

  /* Tetikleyiciler sayfanın her yerinde: ürün kartı, ürün sayfası, arama
     paneli. Dinleyici bu yüzden bileşenin içinde değil modül düzeyinde ve
     YAKALAMA aşamasında duruyor — böylece hem bileşenin yükseltilmesini
     beklemiyor hem de araya giren başka bir dinleyici (kartın tamamını
     kaplayan başlık bağlantısı gibi) tıklamayı kaçırmıyor.

     Bağlantı JS kapalıyken ürün sayfasına gitsin diye <a href> olarak
     duruyor; burada varsayılan davranış yalnızca modal gerçekten açıldığında
     iptal ediliyor. */
  function openNotify(trigger) {
    const modal = document.querySelector('ks-notify');
    if (!modal) return false;
    if (typeof modal.open !== 'function' && window.customElements && customElements.upgrade) {
      customElements.upgrade(modal);
    }
    if (typeof modal.open !== 'function') return false;
    try {
      modal.open(trigger);
    } catch (error) {
      // Modal açılamıyorsa bağlantıyı engelleme: kullanıcı ürün sayfasına
      // gitsin, orada da aynı tetikleyici var.
      console.error('notify', (error && error.message) || error);
      return false;
    }
    return true;
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    const trigger = target && target.closest ? target.closest('[data-notify-open]') : null;
    if (!trigger) return;
    if (!openNotify(trigger)) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);
})();
